/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Dec 10 2024
 **/

import * as Indicator from "./IndicatorIcons";

export const Icons: Record<string, (props: { color: string }) => JSX.Element> = {
	cursor: (props) => <Indicator.Cursor {...props} />,
	pointer: (props) => <Indicator.Pointer {...props} />,
	pointerActive: (props) => <Indicator.PointerActive {...props} />,
	freeline: (props) => <Indicator.Freeline {...props} />,
	line: (props) => <Indicator.Line {...props} />,
	arrow: (props) => <Indicator.Arrow {...props} />,
	marker: (props) => <Indicator.Marker {...props} />,
	circle: (props) => <Indicator.Circle {...props} />,
	rect: (props) => <Indicator.Rect {...props} />,
	emoji: (props) => <Indicator.Cursor {...props} />,
	eraser: (props) => <Indicator.Freeline {...props} />,
	image: (props) => <Indicator.Rect {...props} />
};

export default Icons;
